import { IIssue } from './marketplace-product'

export interface SGPageTemplate {
  title: string
  shortDescription?: string | null
  modules: SGPageTemplateModule[]
}
export type SGPageTemplateModule =
  | SGPageTemplateBasicContent
  | SGPageTemplateContentCollection
  | SGPageTemplateProductCollection
  | SGPageTemplateDynamicContent

export type SGPageTemplateBasicContent = {
  __typename: 'SGPageTemplateBasicContent'
  title: string
  shortDescription: string
  bodyCopy: string
  callsToAction: SGPageTemplateCallToAction[]
}

export type SGPageTemplateContentCollection = {
  __typename: 'SGPageTemplateContentCollection'
  kind: SGPageTemplateContentCollectionKind
  title?: string | null
  shortDescription?: string | null
  items: SGPageTemplateContentEntry[]
  callToAction?: SGPageTemplateCallToAction | null
  analyticsMetadata?: SGPageTemplateDisplayAnalyticsMetadata
}

export type SGPageTemplateProductCollection = {
  __typename: 'SGPageTemplateProductCollection'
  kind: SGPageTemplateProductCollectionKind
  title: string
  shortDescription?: string
  url?: string | null
  image?: SGPageTemplateImage
  items: SGPageTemplateProduct[]
  analyticsMetadata?: SGPageTemplateDisplayAnalyticsMetadata
}

export type SGPageTemplateDisplayAnalyticsMetadata = {
  correlationIds: string[]
  displayId: string
  position: string | null
}

export type SGPageTemplateContentCollectionKind =
  | 'BANNER'
  | 'CATEGORY_GRID'
  | 'COLOUR_CARDS'
  | 'FEATURE'
  | 'INLINE_DECK'
  | 'STORE_GRID'
  | 'UTILITY_PANEL'
  | 'SPOTLIGHT'
  | 'WHATS_HAPPENING_DECK'

export type SGPageTemplateProductCollectionKind =
  | 'COLLECTION_DECK'
  | 'PRODUCT_REEL'

export type SGPageTemplateContentAnalyticsMetadata = {
  correlationId: string
  promotion: {
    creative: string | null
  }
  title: string
}

export type SGPageTemplateContentEntry = {
  __typename: 'SGPageTemplateContentEntry'
  kind: string
  title: string
  image: SGPageTemplateImage
  secondaryImage?: SGPageTemplateImage | null
  shortDescription?: string | null
  callToAction: SGPageTemplateCallToAction
  analyticsMetadata?: SGPageTemplateContentAnalyticsMetadata
  supplementaryText?: string | null
}

export type SGPageTemplateProduct = {
  __typename: 'SGPageTemplateProduct'
  shop: SGPageTemplateProductShop
  variantGroupCode: string
  kind: string
  sku: string
  title: string
  image: {
    url: string
    alt?: string | null
  }
  price: string | null
  percentDiscount?: string | null
  discountedPrice?: string | null
  brand?: string | null
  callToAction: {
    url: string
  }
  issues?: IIssue[]
  category?: string[] | null
  objectID?: string | null
}

interface SGPageTemplateProductShop {
  id: number
  name?: string | null
  retailer?: SGPageTemplateProductRetailer | null
}

interface SGPageTemplateProductRetailer {
  sys: {
    id: string
  }
}

export type SGPageTemplateCallToAction = {
  label: string
  url: string
}

export type SGPageTemplateImage = {
  type: SGPageTemplateImageType
  url: string
  alt?: string | null
  supportingColour?: string | null
  cinemagraphUrl?: string | null
}

export const sgPageTemplateImageTypeValues = ['SQUARE', 'WIDE'] as const
export type SGPageTemplateImageType =
  typeof sgPageTemplateImageTypeValues[number]

export type SGPageTemplateDynamicContent = {
  __typename: 'SGPageTemplateDynamicContent'
  kind: string
}
